import {LegalPage} from "../features/legal/LegalPage"


export default LegalPage.Page
